import { useState } from "react";
import { toast } from "sonner";
import { api, apiErrorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { MailCheck } from "lucide-react";

export default function EmailBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user || user.role === "admin" || user.emailVerified) return null;

  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/resend-verification"); toast.success("Confirmation code sent to your email"); }
    catch (e) { toast.error(apiErrorMessage(e)); }
    finally { setBusy(false); }
  };
  const nextPath = user.role === "streamer" ? "/streamer" : "/onboarding";
  return (
    <div className="bg-[#F5B841]/10 border-b border-[#F5B841]/40" data-testid="email-verify-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center justify-between flex-wrap gap-3 text-sm">
        <div className="flex items-center gap-2 text-[#F5B841]"><MailCheck className="w-4 h-4" /><span>Enter the 6-digit code we sent to your inbox to unlock uploads, top-ups and admin review.</span></div>
        <div className="flex items-center gap-2">
          <Button asChild size="sm" className="rounded-none h-8 px-3 bg-[#F5B841] text-black hover:bg-white transition-colors font-semibold">
            <a href={nextPath} data-testid="goto-code-entry">Enter code</a>
          </Button>
          <Button data-testid="resend-verify" onClick={resend} disabled={busy} size="sm" variant="ghost" className="rounded-none h-8 px-3 text-[#F5B841] hover:bg-[#F5B841]/10 transition-colors">Resend</Button>
        </div>
      </div>
    </div>
  );
}
